import { useEffect, useRef, useState } from "react";

export const VISIBILITY_TIMEOUT = 60000;

export const useVisibilityTabChange = () => {
    const [closeAllWebsocketConnections, setCloseAllWebsocketConnections] = useState(false);
    const timeoutRef = useRef<any>(null);

    const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            // Start a 60-second timeout when the tab is hidden
            timeoutRef.current = setTimeout(() => {
                setCloseAllWebsocketConnections(true);
            }, 60000);
        } else {
            // Clear the timeout if the tab becomes visible again within 60 seconds
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            setCloseAllWebsocketConnections(false);
        }
    };

    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return { closeAllWebsocketConnections };
};
